import React, { FunctionComponent, useState } from 'react';
import Alert from '@justgiving/alert';
import { Trans, useTranslation } from 'react-i18next';
import { useIsMounted } from '../../hooks/useIsMounted';
import {
  DONATION_ERROR,
  ALERT_TYPE_PARAMETER,
  ALERT_MESSAGE_PARAMETER,
  AlertTypes,
} from '../../constants/errorTypes';

const PageAlert: FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const [showAlert, setShowAlert] = useState<boolean>(true);
  const isMounted = useIsMounted();

  const getPageAlertTranslation = (key: string) => {
    switch (key) {
      case `page.alert.${DONATION_ERROR}`: {
        return (
          <Trans i18nKey="page.alert.donationError">
            Looks like we're running into some trouble. You can try donating
            again, or{' '}
            <a href="https://help.justgiving.com/hc/en-us/requests/new?ticket_form_id=5342">
              reach out to our Customer Support team for help
            </a>
            .
          </Trans>
        );
      }
      default: {
        return t('page.errorGeneric.heading');
      }
    }
  };

  if (!isMounted || !window.location.search) {
    return null;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const alertType: AlertTypes =
    (urlParams.get(ALERT_TYPE_PARAMETER) || '') in AlertTypes
      ? (urlParams.get(ALERT_TYPE_PARAMETER) as AlertTypes)
      : AlertTypes.info;
  const alertMessageKey = urlParams.get(ALERT_MESSAGE_PARAMETER);

  if (!showAlert || !alertMessageKey) {
    return null;
  }

  return (
    <Alert type={alertType} onClose={() => setShowAlert(false)}>
      {getPageAlertTranslation(alertMessageKey)}
    </Alert>
  );
};

export default PageAlert;
